// Function to manage visibility based on the selected year
function manageVisibility() {
    const selectedYear = document.getElementById('year').value;
    const awardCards = document.querySelectorAll('[data-year]');

    if (selectedYear === "0") {
        awardCards.forEach((element) => {
            element.classList.remove('hidden');
        });
    } else {
        awardCards.forEach((element) => {
            if (element.getAttribute('data-year') === selectedYear) {
                element.classList.remove('hidden');
            } else {
                element.classList.add('hidden');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const awardCards = document.querySelectorAll('[data-year]');
    const yearDropdown = document.getElementById('year');

    if(yearDropdown && awardCards) {
        // On page load, show the previous 6 award winners, skipping the current winner (already shown in other element)
        manageVisibility();

        // Bind year dropdown filtering
        yearDropdown.addEventListener('change', manageVisibility);
    }
});
